export default __webpack_public_path__ + "static/media/Logo_Nexi_Group_Orizz_Colore.03fb014a.png";